import React from "react";
// tiptap v3 no longer re-exports Node from @tiptap/react (#11904).
import { Node } from "@tiptap/core";
import {
  NodeViewWrapper,
  ReactNodeViewRenderer,
  type NodeViewProps,
} from "@tiptap/react";
import ChartInEditor from "../ChartInEditor";

const ChartInEditorNodeView = ({
  node,
  updateAttributes,
}: Pick<NodeViewProps, "node" | "updateAttributes">) => {
  return (
    <NodeViewWrapper node={node} style={{ width: "100%", height: "100%" }}>
      <ChartInEditor node={node} updateAttributes={updateAttributes} />
    </NodeViewWrapper>
  );
};

const ChartNode = Node.create({
  name: "chart-node",
  group: "block",
  inline: false,
  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      qid: {
        default: null,
      },
      width: {
        default: null,
      },
      height: {
        default: 450,
      },
      align: {
        default: "center",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "chart-node",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["chart-node", HTMLAttributes];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ChartInEditorNodeView);
  },
});

export default ChartNode;
